import { ConfigurationItem } from "constants/configurations";

export const SET_SELECTED_CONFIGURATION_TAB = "SET_SELECTED_CONFIGURATION_TAB";

export type ConfigurationDispatchAction = {
  type: typeof SET_SELECTED_CONFIGURATION_TAB;
  payload: { tab: ConfigurationItem };
};

export const setSelectedConfigurationTab = (
  tab: ConfigurationItem
): ConfigurationDispatchAction => {
  return {
    type: SET_SELECTED_CONFIGURATION_TAB,
    payload: { tab },
  };
};
